import { useContext, useEffect, useRef } from 'react';
import { action } from '../../lib/api.js';
import { useParams } from 'react-router';
import { useSelector } from 'react-redux';
import routes from '@/routes.js';
import selectors from '@/redux/selectors/selectors.js';
import { AuthContext } from '@/lib/contexts/auth.jsx';
import setPath from '@/lib/setPath.js';
import sendToast from '@/lib/sendToast.js';

const RouteWrapperEffectsHandler = (props) => {
  const params = useParams(); // ok
  const reduxParams = useSelector((state) => state.ui.params); // ok
  const isFixedWidth = useSelector((state) => state.ui.fixedWidth);
  const permissions = useSelector(selectors.permissions);
  const lastRouteSlug = useRef(null);
  const { isLoggedIn } = useContext(AuthContext);
  const missingPermissions =
    !isLoggedIn || !permissions?.length
      ? [] //
      : props.permissions?.filter((n) => !permissions?.includes(n));

  // Redirect user to home page if they don't have permission to view the page.
  useEffect(() => {
    if (missingPermissions?.length) {
      sendToast({
        message: `You do not have permission to view this page. (${window.location.pathname})`
      });
      if (window.location.pathname !== '/') {
        setPath('/');
      }
    }
  }, [missingPermissions]);

  useEffect(() => {
    if (props.fixedWidth !== isFixedWidth) {
      action('uiSetFixedWidth', props.fixedWidth === true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.fixedWidth, isFixedWidth]);

  useEffect(() => {
    if (JSON.stringify(reduxParams) === JSON.stringify(params)) {
      return;
    }
    action('SET_PARAMS', params);
  }, [params, reduxParams]);

  useEffect(() => {
    const routeSlug = routes.find((n) => n.id === props.routeId)?.routeId;
    action('uiSetActiveRouteId', props.routeId);
    if (lastRouteSlug.current !== routeSlug) {
      action('uiSetActiveRouteReady', false);
      lastRouteSlug.current = routeSlug;
    }
  }, [props.routeId]);

  useEffect(() => {
    document.body.setAttribute('data-route', props.routeSlug);
  }, [props.routeSlug]);

  return null;
};

export default RouteWrapperEffectsHandler;
